import styled from 'styled-components';

import { Carousel } from 'shared/components/Carousel';
import { IExternalPicture } from 'shared/types/ExternalPicture';
import { GalleryItemDesktop } from './GalleryItemDesktop';

interface IImageGalleryDesktopProps {
  disableCarouselScroll?: boolean;
  itemList: IExternalPicture[] | { mainPictureUrl: string }[];
  productType: string;
  renderImagesInOrder?: boolean;
}

export const ImageGalleryDesktop = ({
  disableCarouselScroll = false,
  itemList,
  productType,
  renderImagesInOrder = false,
}: IImageGalleryDesktopProps) => {
  const isSneaker = productType === 'sneakers';

  return (
    <ImageGalleryDesktop.Wrapper data-qa="image_gallery_desktop">
      <Carousel
        itemList={itemList}
        carouselItem={<GalleryItemDesktop />}
        disableCarouselScroll={disableCarouselScroll}
        keyDownIgnoreFocus
        lazyLoad
        showArrowButtons={itemList.length > 1}
        centeredViewport={!isSneaker || itemList.length === 1 || !renderImagesInOrder}
        showProgressIndicator={!isSneaker && itemList.length > 1}
      />
    </ImageGalleryDesktop.Wrapper>
  );
};

ImageGalleryDesktop.Wrapper = styled.div`
  height: calc(100vh - 126px);

  // NOTE: need to add these styles due to bug in swiper: https://github.com/nolimits4web/swiper/issues/3599
  .swiper-container {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    min-height: 0;
    min-width: 0;
  }

  .swiper-slide {
    width: 100vw !important;
  }
`;
